export default __webpack_public_path__ + "static/media/logo.882b7661.png";